/* 環境 */
export default {
    // ローカル環境
    LOCAL: "local",
    // 開発環境
    DEVELOPMENT: "development",
    // ステージング環境
    STAGING: "staging",
    // 本番環境
    PRODUCTION: "production"
}